const animationProps = new Set([
  "animate",
  "custom",
  "exit",
  "initial",
  "layout",
  "transition",
  "variants",
  "viewport",
  "whileHover",
  "whileInView",
  "whileTap",
]);

const createStaticElement = (Tag) => {
  const StaticElement = ({ children, ...props }) => {
    const cleanProps = {};

    Object.entries(props).forEach(([key, value]) => {
      if (!animationProps.has(key)) {
        cleanProps[key] = value;
      }
    });

    return <Tag {...cleanProps}>{children}</Tag>;
  };

  return StaticElement;
};

export const motion = {
  a: createStaticElement("a"),
  div: createStaticElement("div"),
  h2: createStaticElement("h2"),
  img: createStaticElement("img"),
  p: createStaticElement("p"),
};
